export const EXTRACTION_BUSINESSRULES = 'Extraction-BusinessRules';
export const PRELIMINARY_CATALOG = 'Preliminary-Catalog';
export const CHECKLIST = 'Checklist';
export const DATAMODELLIST = 'DatamodelList';
export const DATAMODEL_VALIDATIONS = 'Datamodel-Validations';
export const DATAMODEL_AGENT = 'Datamodel-Agent';
